import React from 'react';
import { Controller } from 'react-hook-form';
import { Input, PhoneNumberInput } from '@zydalabs/storefront-components';

import { usePersistedCountryDetails } from 'common/hooks';
import { SUPPORTED_COUNTRIES } from 'common/constants';
import { GiftFormType } from './types';

const GiftForm: React.FC<GiftFormType> = ({ fields, errors, control }) => {
  const [persistedCountryDetails] = usePersistedCountryDetails();

  return (
    <>
      <Controller
        control={control}
        name="name"
        render={({ field }) => (
          <Input
            {...field}
            floatingLabel={fields.name}
            autoFocus
            errorMessage={errors?.name?.message}
          />
        )}
      />
      <Controller
        control={control}
        name="phoneNumber"
        render={({ field }) => (
          <PhoneNumberInput
            {...field}
            international
            countries={SUPPORTED_COUNTRIES}
            placeholder={fields.phoneNumber}
            error={errors?.phoneNumber?.message}
            defaultCountry={persistedCountryDetails?.code}
          />
        )}
      />
      <Controller
        control={control}
        name="giftNotes"
        render={({ field }) => (
          <Input {...field} floatingLabel={fields.giftNotes} errorMessage={errors?.giftNotes?.message} />
        )}
      />
    </>
  );
};

export default GiftForm;
